"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.title.placeholder': 'Introducir título del conocimiento',
};
